// extracted by mini-css-extract-plugin
export default {"jumpWiggle":"JumpWiggle-module__jumpWiggle--vJp3H","copilotRun":"JumpWiggle-module__copilotRun--gYxZE"};